import { Pagination } from '@calendly/ui/components/pagination';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingState from 'components/core/loading_state';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
import { ControlsContainer } from '../controls_container';
import { filterTermSelector, isLoadingSelector, migrationsSelector, paginationSelector } from './selectors';
import { initPage, search, updatePage } from './slice';
import { MigratingUsersTable } from './table';
const paginationContainerCss = "p1s20ixw";
const PaginationContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paginationContainerCss, props.className)} />;
});
export const MigratingUsers = () => {
  const dispatch = useDispatch();
  const pagination = useSelector(paginationSelector);
  const migrations = useSelector(migrationsSelector);
  const isLoading = useSelector(isLoadingSelector);
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const handleSearch = query => dispatch(search(query));
  const filterTerm = useSelector(filterTermSelector);
  useEffect(() => {
    dispatch(initPage());
  }, [dispatch]);
  return <>
      <ControlsContainer filterTerm={filterTerm} handleSearch={handleSearch} isAdminOrOwner={isAdminOrOwner} />
      {isLoading && <LoadingState />}
      {!isLoading && <>
          <MigratingUsersTable migrations={migrations} />
          <PaginationContainer>
            <Pagination {...pagination} onPageClick={page => dispatch(updatePage({
          page
        }))} />
          </PaginationContainer>
        </>}
    </>;
};

require("./migrating_users.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./migrating_users.js");